import { MutationTree } from "vuex";
import { SchoolState } from "./types";

export const mutations: MutationTree<SchoolState> = {};
